import { Helmet } from "react-helmet-async";
import "./style.css";
import NavbarTop from "../../components/NavbarTop";
import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import axios from "axios";
import PostList from "../../components/Post/PostList";
import { useAuth, useTheme } from "../../global-components/src";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { errorMessage } from "../../utils/TextManagerTwo";
import { useMessage } from "../../global-components/src";
import FormVerifyEmail from "../../components/FormVerifyEmail/FormVerifyEmail";
import { getViewedAds, updateViewedAds } from "../../utils/ads";
import { getViewedRange } from "../../utils/feed"; 
import { useFeed } from "../../contexts/FeedContext";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { authUser, getImageUser, getImageUserNotFound, validateEmail, validateUsername } from "../../global-components/src/utils/auth";
import { TriangleAlert, Search, UserMinus, X, Vote } from "lucide-react";
import { hasNewVersion, isDesktop } from "../../utils/platform";
import NewVersionAvaliable from "../../components/new-version-avaliable/new-version-avaliable";
import NotificationDownloadApp from "../../components/notification-download-app/notification-download-app";
import ModalComments from "../../components/Modals/comments/modal-comments";
import ModalCommentsBottom from "../../components/Modals/comments/comments-bottom";
import ModalPostLikesBottom from "../../components/Modals/post-likes/post-likes-bottom";
import ModalPostLikes from "../../components/Modals/post-likes/post-likes";
import { LeftContent, RightContent, SponsoredContent } from "../../global-components/src/components/screen/left-content";
import { Community, Post } from "../../types";
import UserSearch from "../Settings/SearchScreen/User/User";
import { getImageNotFound, getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { PostLoading } from "../../components/Post/post-loading";
import { Icon } from "../../global-components/src/components/icon";
import StoriesBar from "../../components/stories/stories-bar";
import { useAddPost } from "../../contexts/AddPostContext";
import RateApp from "../../components/new-version-avaliable/rate-app";
import AddAccountBottom from "../../global-components/src/components/add-account-bottom";
import { useTranslation } from "react-i18next";
import { User } from "../../global-components/src/types";
import BranTokensWallet from "../../components/Modals/bran-tokens-wallet/bran-tokens-wallet";
import BranTokensWalletBottom from "../../components/Modals/bran-tokens-wallet/add-post-bottom";
import { api } from "../../services/api";
import i18n from "../../global-components/src/i18n";
import { getPromoPost } from "../../utils/promo-posts";
import PeopleYouMayKnow from "../../components/PeopleYouMayKnow/PeopleYouMayKnow";

const Feed: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [loadingDefaultUser, setLoadingDefaultUser] = useState(false);
    const [openAddAccount, setOpenAddAccount] = useState(false);
    const [openBranTokenWallet, setOpenBranTokenWallet] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const { user, isAuthenticated, token } = useAuth();
    const navigate = useNavigate();
    const { setMessage } = useMessage();
    const location = useLocation();
    const pageUrl = useRef(`${window.location.origin}${location.pathname}`);
    const [showModalLikes, setShowModalLikes] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [isOpenNewVersion, setIsOpenNewVersion] = useState(false);
    const [isOpenRateApp, setIsOpenRateApp] = useState(!!sessionStorage.getItem("RateAppOpen") && isAuthenticated);
    const ogImage = useRef("/img/pacoca-sem-braco-fundo-rounded.png");
    const [idPostSelected, setIdPostSelected] = useState<number | null>(null)
    const { posts, setPosts, feedType, setFeedType, end, setEnd, page, setPage, cursor, setCursor, setAnchorId } = useFeed();
    const [users, setUsers] = useState<User[] | null>(null);
    const [communities, setCommunities] = useState<Community[]>([]);
    const feedRef = useRef<HTMLDivElement>(null);
    const startY = useRef<number | null>(null);
    const startX = useRef<number | null>(null);
    const [readyToRefresh, setReadyToRefresh] = useState(false);
    const { isDarkMode, hideBranToken, hideMenuMobile, isNewPacoca } = useTheme();
    const path = useRef(location.pathname);
    const { setOpen: setOpenPost } = useAddPost();
    const isNewerThanTwoDays = useMemo(() => user?.created_at ? (new Date().getTime() - new Date(user.created_at).getTime()) < (2 * 24 * 60 * 60 * 1000) : false, [user?.created_at]);
    const { t } = useTranslation();
    const [showBanner, setShowBanner] = useState(false);
    const [showElectionBanner, setShowElectionBanner] = useState(false);
    const [showActiveNotification, setShowActiveNotification] = useState(false);
    const [showActiveModerator2FA, setShowActiveModerator2FA] = useState(false);
    
    useEffect(() => {
        if (isAuthenticated && isNewerThanTwoDays && !user?.email_verified_at && !localStorage.getItem("hideWelcomeBanner")) {
            setShowBanner(true);
            return;
        }
    }, [user]);
    
    useEffect(() => {
        if (!localStorage.getItem("hideElectionBanner") && !isNewerThanTwoDays) {
            setShowElectionBanner(true);
            return;
        }
    }, []);

    const handleCloseBanner = () => {
        localStorage.setItem("hideWelcomeBanner", "true");
        setShowBanner(false);
    };
    
    const handleCloseElectionBanner = () => {
        localStorage.setItem("hideElectionBanner", "true");
        setShowElectionBanner(false);
    };
    
    useEffect(() => {
        if(!user || !isAuthenticated) return;

        if ((user?.position > 0 || user?.stamps?.includes("brown")) && !user.google2fa_enabled) {
            setShowActiveModerator2FA(!localStorage.getItem("hideActiveNotification"));
            return;
        }
    }, [user]);
    
    useEffect(() => {
        if (isAuthenticated) {
            setShowActiveNotification(!localStorage.getItem("hideActiveNotification"));
            return;
        }
    }, [user]);

    const handleCloseModerator2FA = () => {
        localStorage.setItem("hideActiveModerator2FA", "true");
        setShowActiveModerator2FA(false);
    };

    const handleCloseBannerNotification = () => {
        localStorage.setItem("hideActiveNotification", "true");
        setShowActiveNotification(false);
    };

    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Rede Social Paçoca",
        "url": pageUrl.current,
        "description": "Paçoca é uma rede social inovadora que permite você se conectar com pessoas ao redor do mundo, fazer novos amigos e compartilhar momentos.",
        "image": ogImage,
        "publisher": {
            "@type": "Organization",
            "name": "Paçoca Inc.",
            "logo": {
                "@type": "ImageObject",
                "url": ogImage
            }
        }
    };

    useEffect(() => {
        setFeedType(!isAuthenticated ? "feed" : feedType);
    }, [user])

    // useEffect(() => {
    //     const saveScroll = () => {
    //         if (location.pathname === "/") {
    //             sessionStorage.setItem("feed-scroll", String(window.scrollY));
    //         }
    //     };

    //     window.addEventListener("scroll", saveScroll, { passive: true });

    //     return () => window.removeEventListener("scroll", saveScroll);
    // }, []);


    // const previousPath = useRef(location.pathname);
    // useEffect(() => {
    //     if (previousPath.current === "/" && location.pathname !== "/") {
    //         // Está saindo do feed
    //         sessionStorage.setItem("feed-scroll", String(window.scrollY));
    //     }

    //     previousPath.current = location.pathname;
    // }, [location.pathname]);

    // useEffect(() => {
    //     if (location.pathname !== "/" || posts.length === 0) return;

    //     const y = Number(sessionStorage.getItem("feed-scroll"));
    //     if (!y) return;

    //     const restoreWhenReady = () => {
    //         // Só restaura quando a página já tem altura suficiente
    //         if (document.documentElement.scrollHeight >= y + window.innerHeight) {
    //             window.scrollTo(0, y);
    //         } else {
    //             requestAnimationFrame(restoreWhenReady);
    //         }
    //     };

    //     requestAnimationFrame(restoreWhenReady);

    // }, [location.pathname, posts.length]);



    const changeFeedType = (type: "not_displayed" | "feed" | "following") => {
        if (loading) return; // Ignora se já está carregando
        if((type == "following" || type == "not_displayed") && !isAuthenticated)
            navigate("/login")

        setAnchorId(null);
        loadPosts(null, type);
        setEnd(false);
        setFeedType(type);
        setPosts([]);
        setPage(1);
        setCursor(null);
    }

    useEffect(() => {
        // reseta feed pelo menu
        if(page == -1){
            setPage(1);
            setCursor(null);
            loadPosts(null);
            setEnd(false);
            setPosts([]);
        } else {
            loadPosts(cursor);
        }
    }, [page])

    useEffect(() => {
        return () => {
            setPage(1);
            setCursor(null);
            loadPosts(null);
            setEnd(false);
            setPosts([]);
        } 
    }, [])

    const handleTouchStart = (e: TouchEvent) => {
        // Só começa a detectar refresh se estiver no topo da página
        if (window.scrollY === 0) {
            startY.current = e.touches[0].clientY;
            startX.current = e.touches[0].clientX; // Guarda posição X inicial
        } else {
            startY.current = null;
            startX.current = null;
        }
    };

    const handleTouchMove = (e: TouchEvent) => {
       if (startY.current === null || startX.current === null) return;

        const currentY = e.touches[0].clientY;
        const currentX = e.touches[0].clientX;
    
        // Calcula a distância vertical e horizontal
        const deltaY = currentY - startY.current;
        const deltaX = currentX - startX.current;

        const target = e.target as HTMLElement;
        if (target.closest(".modal") || window.scrollY > 0 || target.closest(".react-modal-sheet-container")) return;

        if (Math.abs(deltaY) > Math.abs(deltaX) * 2) {
        // Só permite arrasto para baixo (refresh)
            if (deltaY > 0) {
                e.preventDefault();
                const pullDistance = Math.min(deltaY * 0.5, 100);
                
                // Define como readyToRefresh somente se passar do threshold
                if (pullDistance > 60 && !refreshing) {
                    setReadyToRefresh(true);
                } else {
                    setReadyToRefresh(false);
                }
            }
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const referral = params.get("referral_code");

        if (referral) {
            sessionStorage.setItem("referral_code", referral);
        }
    }, [location.search]);
    
    const handleTouchEnd = async () => {
        if (readyToRefresh && !refreshing) {
            setRefreshing(true);
            setReadyToRefresh(false);
            await loadPosts(null, feedType, true);
            setRefreshing(false);
        }
        // setReadyToRefresh(false);
            startY.current = null;
        };

        useEffect(() => {
        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handleTouchMove);
        window.addEventListener("touchend", handleTouchEnd);

        return () => {
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("touchend", handleTouchEnd);
        };
    }, [readyToRefresh, refreshing]);

    const loadPosts = async (cursorParam: number | null = cursor, feedTypeLocal?: string, reloadFeed?: boolean) => {
        feedTypeLocal = feedTypeLocal ? feedTypeLocal : feedType;
        const publicUrl = !isAuthenticated ? "/public" : "";

        // anuncios já vistos
        const viewedAds = getViewedAds();
        const viewedAdsParam = viewedAds.join(',');

        // range de ids, para não retornar posts vistos 
        // const currentRange = getViewedRange(feedTypeLocal);
        let url: string;

        // const viewedIds = getViewedIds(feedTypeLocal);
        // const viewedIdsParam = viewedIds.join(',');


        if(feedTypeLocal == "not_displayed" || feedTypeLocal == "following")
            url = `${publicUrl}/posts?feedType=${feedTypeLocal}&hide_posts_community=${2}&viewed_ads=${viewedAdsParam}`;
        else
            url = `${publicUrl}/posts?feedType=${feedTypeLocal}&hide_posts_community=${2}&viewed_ads=${viewedAdsParam}`;

        if (cursorParam) {
            url += `&cursor=${cursorParam}`;
        }


        if (loading || end) return;
        setLoading(true);

        try {
            // const response = await axios.get(url, {
            //     // timeout: 3000,
            //     headers: {
            //         "Content-Type": "application/json",
            //         "Accept": "application/json",
            //         "Authorization": `Bearer ${token}`
            //     }
            // });
            const response = await api(token).get(url);

            const data = response.data.posts;
            setCursor(response.data.next_cursor);

            if (data.length > 0) {
                if (reloadFeed) setPosts([]);

                // Resolve promo post eagerly (outside state updater) so localStorage
                // timestamp is only written once, even in React StrictMode.
                const promoPostCandidate = getPromoPost();

                setPosts(prev => {
                    const prevIds = new Set(prev.map(p => p.id));

                    const filtered = data.filter((p: Post) => !prevIds.has(p.id));

                    const newPosts = filtered.filter((post: any) => {

                        if (!post.is_hidden) {
                            return true;
                        }

                        const userPost = post.user;

                        const canSeeHidden =
                            (userPost?.position ?? 0) > 0 ||
                            userPost?.stamps?.includes("brown") ||
                            userPost?.id == user?.id;

                        if (canSeeHidden) {
                            post.is_hidden = false;
                            post.hidden_reason = null;
                            return true;
                        }

                        return false;
                    });

                    // Inject promo post on first page only (prev is empty) and at most once
                    const isFirstPage = prev.length === 0;
                    const alreadyHasPromo = prev.some(p => p.id < 0);
                    if (isFirstPage && !alreadyHasPromo && promoPostCandidate) {
                        const insertAt = Math.min(2, newPosts.length);
                        newPosts.splice(insertAt, 0, promoPostCandidate);
                    }

                    return [...prev, ...newPosts];
                });

                updateViewedAds(data);
                saveViewedIds(data);
            } else {
                localStorage.removeItem(`viewedIds_${feedTypeLocal}`);
                setEnd(true);
                setPage(1);
                setCursor(null);
            }

        } catch (err: any) {
            console.error("Failed to load posts:", err);
            setEnd(true);
            const messageError = errorMessage(err);
            setMessage(messageError, "error")
            // if (err.status == 429)
        } finally {
            setLoading(false);
        }
    };

    const getViewedIds = (feedType: string): number[] => {
        const raw = localStorage.getItem(`viewedIds_${feedType}`);
        return raw ? JSON.parse(raw) : [];
    };

    // const saveViewedIds = (feedType: string, posts: Post[]) => {
    //     const MAX_VIEWED = 500;

    //     const stored = getViewedIds(feedType);
    //     const newIds = posts.map(p => p.id);

    //     const merged = Array.from(new Set([...stored, ...newIds]));

    //     // remove os mais antigos
    //     const trimmed =
    //         merged.length > MAX_VIEWED
    //             ? merged.slice(merged.length - MAX_VIEWED)
    //             : merged;

    //     localStorage.setItem(
    //         `viewedIds_${feedType}`,
    //         JSON.stringify(trimmed)
    //     );
    // };
   // utils/viewedPosts.ts

   const saveViewedIds = (posts: Post[]) => {
        if (!isAuthenticated) return;
        posts.forEach(p => queueViewedPost(p.id));
        flushViewedPosts(token);
    };

    const pendingIds = new Set<number>();
    let debounceTimer: ReturnType<typeof setTimeout>;

    const queueViewedPost = (id: number) => {
        pendingIds.add(id);
    };

    const flushViewedPosts = (token: string) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(async () => {
            if (!pendingIds.size) return;
            const ids = Array.from(pendingIds);
            pendingIds.clear();

            try {
                await axios.post(PACOCA_API_URL + '/posts/mark-viewed', {
                    post_ids: ids.join(',')
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } catch (error) {
                console.error(error);
            }
        }, 2000); // aguarda 2s antes de enviar
    };

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting) {
                if (!loading && !end && user?.id) setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        const handleModalClose = () => {
            setShowModalLikes(false)
            setShowModalComments(false)
            setIdPostSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);
    
    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    const inputLogin = () => {
        if(!isAuthenticated) return { onClick: () => navigate("/login") }

       return { onClick: () => setOpenPost(true) }
        // return { "data-bs-toggle": "modal", "data-bs-target": "#modal-post", onClick: () => {} }
    }

    useEffect(() => {
        if(isAuthenticated && window.innerWidth >= 850){
            handleUser()
            handleCommunity()
        }
    }, []);

    useEffect(() => {
        if(!hideMenuMobile) return;
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            const menu = document.querySelector('.button-add-post-feed') as HTMLElement;
            if (!menu) return;

            if (window.innerWidth <= 850) {
                if (window.scrollY > lastScrollY) {
                    menu.classList.add("hidden-bottom-button");
                } else {
                    menu.classList.remove("hidden-bottom-button");
                }
            }
            lastScrollY = window.scrollY;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [path]);

    const handleUser = async () => {
        if (loadingDefaultUser) return;
        setLoadingDefaultUser(true)
        // setPosts([])
        

        const text = "default-user";

        // Carrega mensagens locais ANTES de buscar na API
        const stored = localStorage.getItem(`default-user`);
        if (stored) {
            try {
                const localData = JSON.parse(stored);
                setUsers(localData)
            } catch (error) {
                
            }
        }


        try {
            const url = `${PACOCA_API_URL}/search?page=0&typeSeach=${"user"}&search=${text}`;


            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;


            if (text == "default-user" && data?.users?.length)
                localStorage.setItem("default-user", JSON.stringify(data?.users))

            if (data.users)
                setUsers(data.users)

        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro ao pesquisar: ", messageError);
            console.error("Erro ao pesquisar: ", err);
            if (err.status == 401) {

            }

        } finally {
            setLoadingDefaultUser(false)
        }
    }

    const handleCommunity = async () => {
        if (loadingDefaultUser) return;
        setLoadingDefaultUser(true)
        // setPosts([])
        

        const text = "default-group";

        // Carrega mensagens locais ANTES de buscar na API
        const stored = localStorage.getItem(`default-group`);
        if (stored) {
            try {
                const localData = JSON.parse(stored);
                setCommunities(localData)
            } catch (error) {
                
            }
        }

        try {
            const url = `${PACOCA_API_URL}/search?page=0&typeSeach=${"group"}&search=${text}&limiteUsuarios=5`;


            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (text == "default-group" && data?.communities?.length)
                localStorage.setItem("default-group", JSON.stringify(data?.communities))

            if (data.communities)
                setCommunities(data.communities)

        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro ao pesquisar: ", messageError);
            console.error("Erro ao pesquisar: ", err);
            if (err.status == 401) {

            }

        } finally {
            setLoadingDefaultUser(false)
        }

    };

    return (
        <>

            {(user?.id == 23674 || user?.id == 23786) && (
                <div style={{ position: "absolute", left: 0, right: 0, top: 0, bottom: 0, background: "#fff", zIndex: 999 }}></div>
            )}
            {!isOpenNewVersion && hasNewVersion() ? (
                <NewVersionAvaliable loadPosts={loadPosts} setIsOpenNewVersion={setIsOpenNewVersion}/>
            ) : (
                <div className={`container container-feed`} style={{ paddingTop: "60px", minWidth: "100%!important", minHeight: "100dvh" }}>
                    <Helmet>
                        <title>Paçoca</title>
                        <meta name="description" content="Conecte-se com pessoas e faça novos amigos na Paçoca, a rede social inovadora e divertida." />
                        <meta name="keywords" content="Paçoca, rede social, fazer amigos, conexões online, comunidade digital, rede social brasileira, criar perfil online, compartilhar momentos" />
                        <meta name="author" content="Paçoca Inc." />
                        <meta property="og:title" content="Paçoca - A rede social 100% brasileira" />
                        <meta property="og:description" content="Conecte-se com pessoas e faça novos amigos na Paçoca, a rede social inovadora e divertida." />
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:locale" content="pt_BR" />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:type" content="website" />
                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content="Paçoca - A rede social 100% brasileira" />
                        <meta name="twitter:description" content="Conecte-se com pessoas e faça novos amigos na Paçoca, a rede social inovadora e divertida." />
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                        {/* Schema Markup */}
                        <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
                    </Helmet>
                    <RateApp isOpen={isOpenRateApp} setIsOpen={setIsOpenRateApp} />

                    {/* {true ? ( */}
                        <>
                            <LeftContent>
                                {isAuthenticated ? (
                                    <>
                                        <div className="card-left" style={{ borderRadius:"50%" }}>
                                            <h5>{t("user.follow.follow")}</h5>
                                            {users?.map((user, index) => (
                                                <UserSearch clasNameSearch="name-communities" clasImgAccount="img-user-left" key={index} user={user} />
                                            ))}
                                        </div>

                                        <div className="card-left" style={{ borderRadius:"50%" }}>
                                            <h5>{t("community.title")}</h5>
                                            {communities?.map((community, index) => (
                                                <div key={index} className="notification_opened row-notification open-notification row-user">
                                                    <img className="user-select-none col-1 img-community-left" src={getImagePathBucketPacoca(community.img, getImageNotFound(community.name))} onError={(e) => { e.currentTarget.src = getImageNotFound(community.name); }} />
                                                    <div className="col" style={{ paddingLeft: "5px", overflow: "hidden",  }} onClick={() => navigate(`/comunidades/${community.id}`)}>
                                                        <h5 className="h5-name-search name-card-search-user" style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
                                                            <Link className="name-communities" style={{ marginRight: 5 }} to={`/comunidades/${community.id}`}>{community?.name}</Link>
                                                        </h5>
                                                        <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>{community?.description}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ): null}
                            </LeftContent>

                            <RightContent>
                               <SponsoredContent/>
                            </RightContent>

                        </>
                    {/* ) : null} */}

                    {refreshing && (
                        <div className="refreshing">
                            <img src="/img/loading.gif" alt="" height={30} />
                        </div>
                    )}

                    {readyToRefresh && (
                        <div className="refreshing">
                            <img src="/img/loading.gif" alt="" height={20} />
                        </div>
                    )}

                    {/* {isLiquidGlass ? (
                        <button className="button-add-post-feed" {...inputLogin()} style={{ bottom: isLiquidGlass ? bottomPadding + 20 : bottomPadding }}>
                            <div style={{ marginBottom: -7 }}>
                                    <Icon size={30} style={{ marginRight: 0 }} invertColor={!isDarkMode} name="add">
                                        <Plus opacity={.6} size={23}/>
                                    </Icon>
                            </div>
                        </button>
                    ): null} */} 
                    
                    <AddAccountBottom open={openAddAccount} setOpen={setOpenAddAccount}/>
                    
                    <div className="row" style={{ justifyContent: "center" }}>
                        <div className="col-md-4" style={{ position: "relative" }}>
                            <NavbarTop showMenuIcon={isAuthenticated}>
                                {/* <button className="none-pc icon-small-menu-top" onClick={() => navigate("/comunidades")} aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: 1 }} type="button">
                                    <Icon size={24} style={{ margin: 0 }} invertColor={!isDarkMode} name="diversity_1">
                                        <Users opacity={.6} size={23}/>
                                    </Icon>
                                </button> */}
                               
                                <button className="none-pc icon-small-menu-top" onClick={() => navigate("/pesquisa")} aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: 1 }} type="button">
                                    <Icon size={24} style={{ margin: 0 }} invertColor={!isDarkMode} name="search">
                                        <Search opacity={.6} size={23}/>
                                    </Icon>
                                </button>
                            </NavbarTop>
                            
                            <div className="none-cel">
                                <div className="scroll-none user-select-none d-flex card-post menu-seguindo" id="row-type-feed">
                                    <div className={`col type-feed cursor-pointer ${feedType === "not_displayed" ? "feed-active" : ""}`} id="not_displayed" onClick={() => changeFeedType("not_displayed")}>
                                        <p>{t("feed.explore")}</p>
                                    </div>
                                    <div className={`col type-feed cursor-pointer ${feedType === "feed" ? "feed-active" : ""}`} id="feed" onClick={() => changeFeedType("feed")}>
                                        <p>{t("feed.recents")}</p>
                                    </div>
                                    <div className={`col type-feed cursor-pointer ${feedType === "following" ? "feed-active" : ""}`} id="following" onClick={() => changeFeedType("following")}>
                                        <p>{t("feed.following")}</p>
                                    </div>
                                </div> 
                            </div>

                            <div className="none-pc">
                                <div className="scroll-none user-select-none d-flex card-post menu-seguindo justify-content-center row-fillter-notifications" id="row-type-feed">
                                    <button style={{ width: 100, height: 25, fontSize: 13, display: "flex", justifyContent: "center", alignItems: "center" }}  className={`btn col-notification btn-light all ${feedType === "not_displayed" ? "notification-type-active" : ""}`} onClick={() => changeFeedType("not_displayed")}>
                                        <p>{t("feed.explore")}</p>
                                    </button>
                                    <button style={{ width: 100, height: 25, fontSize: 13, display: "flex", justifyContent: "center", alignItems: "center" }}  className={`btn col-notification btn-light mention ${feedType === "feed" ? "notification-type-active" : ""}`} onClick={() => changeFeedType("feed")}>
                                        <p>{t("feed.recents")}</p>
                                    </button>
                                    <button style={{ width: 100, height: 25, fontSize: 13, display: "flex", justifyContent: "center", alignItems: "center" }}  className={`btn col-notification btn-light comment ${feedType === "following" ? "notification-type-active" : ""}`} onClick={() => changeFeedType("following")}>
                                        <p>{t("feed.following")}</p>
                                    </button>
                                </div>
                            </div>

                            <NotificationDownloadApp/>
                            
                            {isAuthenticated && <StoriesBar /> }
                            <PeopleYouMayKnow />

                            {/* && isOlderThanTwoDays */}
                            <div className="card card-post card-create-post">
                                {user?.id && !user?.email_verified_at && typeof user?.email_verified_at !== 'undefined' && isAuthenticated ? (
                                    <div className="verify-warning" style={{ marginTop: -5 }}>
                                        <span className="icon user-select-none">
                                            <TriangleAlert className="content" opacity={.6} size={23} />
                                        </span>
                                        <div className="content">
                                            <div style={{ marginBottom: 5 }}>
                                                {t("user.validate.email.verifyEmail")} <Link to={"/@joao"}>@joao</Link>, <Link to={"/@bochecha"}>@bochecha</Link>, <Link to={"/@Diogo.Carvalho"}>@Diogo.Carvalho</Link> ou <Link to={"/@polly"}>@polly</Link>
                                            </div>
                                            <FormVerifyEmail />
                                        </div>
                                    </div>
                                ) : null}
                                
                                {(() => {
                                    if (!user?.next_payment || user.user_name == "test123") return null;

                                    const now = new Date();

                                    const expiration = new Date(user.next_payment);
                                    expiration.setDate(expiration.getDate() + 1);

                                    const diffDays = Math.floor(
                                        (expiration.getTime() - now.getTime()) /
                                        (1000 * 60 * 60 * 24)
                                    );

                                    // Se estiver fora da janela de ±7 dias
                                    if (Math.abs(diffDays) > 7) {
                                        return null;
                                    }

                                    const isExpired = diffDays < 0;
                                    // só aparece se faltar 10 dias ou menos
                                    return (
                                        <div className="verify-warning" style={{ marginTop: -5 }}>
                                            <span className="icon user-select-none">
                                                <TriangleAlert className="content" opacity={.6} size={23} />
                                            </span>
                                            <div className="content">
                                                {new Date(String(user?.next_payment)) < new Date() ? (
                                                    <>
                                                        {t("user.verifiedExpired")} <strong>{expiration.toLocaleDateString()}</strong>.{" "} <Link to="/verificado" className="renew">{t("user.renew")}</Link>
                                                    </>
                                                ) : (
                                                    <>
                                                        {t("user.verifiedWillExpire")} <strong>{expiration.toLocaleDateString()}</strong>.{" "} <Link to="/verificado" className="renew">{t("user.renew")}</Link>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    );

                                    return null;
                                })()}

                                {/* {showElectionBanner ? (
                                    <div className="verify-success" style={{ marginTop: -5 }}>
                                        <button onClick={handleCloseElectionBanner} className="close close-green"
                                        style={{
                                            position: "absolute",
                                            right: 2,
                                            top: 2,
                                        }}>
                                            <X className="content"/>
                                        </button>
                                        <span className="icon user-select-none">
                                            <Vote className="content" opacity={.6} size={23}/>
                                        </span>
                                        <div className="content">
                                            {t("election.description")} <Link to="/urna-votacao" className="renew">{t("election.title")}</Link>
                                        </div>
                                    </div>
                                ) : null} */}
                                
                                {user?.id && validateUsername(user?.user_name) && isAuthenticated ? (
                                    <div className="verify-warning" style={{ marginTop: -5 }}>
                                        <span className="icon user-select-none">
                                            <TriangleAlert className="content" opacity={.6} size={23} />
                                        </span>
                                        <div className="content">
                                            {validateUsername(user?.user_name)} {t("user.validate.username.updateRequired")} <Link to="/conta" className="renew">{t("user.validate.username.update")}</Link>
                                        </div>
                                    </div>
                                ) : null}
                               
                                {user?.id && validateEmail(user?.email) && isAuthenticated ? (
                                    <div className="verify-warning" style={{ marginTop: -5 }}>
                                        <span className="icon user-select-none">
                                            <TriangleAlert className="content" opacity={.6} size={23} />
                                        </span>
                                        <div className="content">
                                            {validateEmail(user?.email)} {t("user.validate.email.updateRequired")} <Link to="/conta?type=email" className="renew">{t("user.validate.email.update")}</Link>
                                        </div>
                                    </div>
                                ) : null}

                                {showActiveModerator2FA ? (
                                        <div className="verify-warning" style={{ marginTop: -5 }}>
                                            <button
                                            onClick={handleCloseModerator2FA}
                                            style={{
                                                position: "absolute",
                                                right: 2,
                                                top: 2,
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                fontSize: 13
                                            }}
                                            >
                                            <X className="content"/>
                                            </button>

                                            <span className="icon user-select-none">
                                                <TriangleAlert className="content" opacity={.6} size={23} />
                                            </span>
                                            <div className="content">
                                                {i18n.t("settings.2fa.modetator")}
                                                <Link to={"/2fa"}>{i18n.t("settings.2fa.2fa")}</Link>
                                            </div>
                                        </div>
                                ) : null}

                                {
                                    typeof window !== "undefined" &&
                                    !(window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === "function") && 
                                    ("Notification" in window) &&
                                    Notification.permission !== "granted" &&
                                    showActiveNotification &&
                                    isDesktop() ? (
                                        <div className="verify-warning" style={{ marginTop: -5 }}>
                                            <button
                                            onClick={handleCloseBannerNotification}
                                            style={{
                                                position: "absolute",
                                                right: 13,
                                                top: 10,
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                fontSize: 12,
                                                color: "var(--color-text-post)"
                                            }}
                                            >
                                            <X className="content"/>
                                            </button>

                                            <span className="icon user-select-none">
                                                <TriangleAlert className="content" opacity={.6} size={23} />
                                            </span>
                                            <div className="content">
                                                Ative as notificações do navegador.
                                            </div>
                                        </div>
                                    ) : null}

                               {showBanner && (
                                    <div className="verify-success" style={{ marginTop: -5, position: "relative" }}>
                                        
                                        <button
                                        onClick={handleCloseBanner}
                                        style={{
                                            position: "absolute",
                                            right: 2,
                                            top: 2,
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: 13
                                        }}
                                        >
                                        ✖
                                        </button>

                                        <span className="icon user-select-none">ℹ️</span>
                                        <div className="content">
                                        Diferenciais do Paçoca: Comunidades. Sistema de livros para mostrar no perfil. 
                                        Os moderadores são usuários do app com o selo vermelho. 
                                        Molduras na foto de perfil. Banner no perfil. Postar audios no feed. 
                                        Fotos de perfil animadas com gif. Dashboard público com os dados. 
                                        Vários selos com cores diferentes. Poucos anúncios e com design elegante.
                                        É possível adicionar todos os seus gostos no perfil.
                                        Marque @pacoca_ai no feed ou comentários pra IA responder.
                                        Criada e desenvolvida apenas pelo <Link to={"/@joao"}>@joao</Link> que recebeu apoio depois de um ano de moderadores e do <Link to={"/@bochecha"}>@bochecha</Link>. 
                                        </div>
                                    </div>
                                )}


                                <div className="row" style={{ width: "100%", margin: 0, padding: 0, flexWrap: "nowrap" }}>
                                    <input type="file" className="d-none" accept="image/*" title="Inserir imagem" />

                                    <div className="none-cel col">
                                        <input {...inputLogin()} type="button" className="form-control text-btn-add-post form-text-comment me-2" name="" value={t("post.textNewPost")} />
                                    </div>
                                    <div className="none-pc col">
                                        {!isNewPacoca ? (
                                            <input {...inputLogin()} type="button" className="form-control text-btn-add-post form-text-comment me-2" name="" value={t("post.textNewPost")} />
                                        ): (
                                            <div className="d-flex">
                                                <img className="img-account-feed" onError={(e) => { e.currentTarget.src = getImageUserNotFound(user?.name); }} src={getImageUser(user?.img_account, undefined, user?.name)} alt=""/>
                                                <div className="col">
                                                    {isAuthenticated ? (
                                                        <p className="username-feed">@{user?.user_name}</p>
                                                    ) : (
                                                        <div style={{ height: 7 }}></div>
                                                    )}
                                                    <p {...inputLogin()} style={{ marginBottom: 0 }} className="textare-new-pacoca">{t("post.textNewPost")}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <PostList googleAds showFollowUser feedInnerRef={feedRef}  onOpenComments={(idPost) => {setShowModalComments(true); setIdPostSelected(idPost)}} onOpenLikes={(idPost) => {setShowModalLikes(true); setIdPostSelected(idPost)}} posts={posts} setPosts={setPosts} />

                            <PostLoading loading={loading}/>

                            {feedType == "following" && !posts.length && !loading &&  (
                                <div className="user-select-none row mt-5">
                                    <span className="span-empty">
                                        <UserMinus className="icon-empty" />
                                        <h3 className="w-100 text-center">{t("feed.followMore")}</h3>
                                    </span>
                                </div>
                            )}


                            <div ref={endOfListRef}></div>
                        </div>
                    </div>

                    {window.innerWidth <=850 ? <BranTokensWalletBottom open={openBranTokenWallet} setOpen={setOpenBranTokenWallet}/> : <BranTokensWallet open={openBranTokenWallet} setOpen={setOpenBranTokenWallet}/>}

                    {(!hideBranToken && isAuthenticated) && (
                        <div className="farelo-login user-select-none" onClick={() => { setOpenBranTokenWallet(prev => !prev) }}>
                            <img className='bran-token-img-feed' src="/img/token.png" alt="" />
                            <div className="none-cel">Air Drop</div>
                        </div>
                    )}

                    {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected}/> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}
                    {window.innerWidth <= 850 ? <ModalPostLikesBottom setOpen={setShowModalLikes} open={showModalLikes} idPostSelected={idPostSelected}/> : <ModalPostLikes setOpen={setShowModalLikes} open={showModalLikes} idPostSelected={idPostSelected}/>}
                </div>
            )}
        </>
    );
};

export default Feed;